import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-dialogdelaccount',
    templateUrl: './dialogdelaccount.component.html',
    styleUrls: ['./dialogdelaccount.component.css'],
    standalone: false
})
export class DialogdelaccountComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
